import React from "react";
import PropTypes from "prop-types";
import Downshift from "downshift";
import styled from "styled-components";

import {
  List,
  ListItem
} from "components/UI/SearchDropdown/SearchDropdown.styles";

const Wrapper = styled.div`
  position: relative;
  flex: 0 1;
`;

const Ul = styled(List)`
  display: block;
  top: 38px;
`;

const Li = styled(ListItem)`
  height: 30px;
`;

const Input = styled.input`
  border: none;
  border-bottom: ${p => `1px solid ${p.theme.colors.iron}`};
  height: 36px;
  font-size: 14px;
`;

const stateReducer = (_, changes) => {
  switch (changes.type) {
    case Downshift.stateChangeTypes.changeInput:
      return {
        selectedItem: null,
        ...changes
      };
    default:
      return changes;
  }
};

const HomeWorkListStateDropdown = ({
  items,
  onSelection,
  inputValue,
  onInputValueChange,
  ...otherProps
}) => {
  return (
    <Downshift
      inputValue={inputValue}
      onInputValueChange={onInputValueChange}
      onChange={onSelection}
      itemToString={item => (item ? item.text : "")}
      stateReducer={stateReducer}
      defaultHighlightedIndex={0}
    >
      {({
        isOpen,
        innerRef,
        inputValue,
        getMenuProps,
        getItemProps,
        getRootProps,
        getInputProps,
        highlightedIndex
      }) => (
        <Wrapper innerRef={innerRef} {...getRootProps({ refKey: "innerRef" })}>
          <Input
            {...getInputProps({
              ...otherProps,
              placeholder: "Filter by State..."
            })}
          />
          {isOpen ? (
            <Ul {...getMenuProps({ isOpen })}>
              {items
                .filter(item =>
                  item.text.toLowerCase().startsWith(inputValue.toLowerCase())
                )
                .map((item, index) => (
                  <Li
                    {...getItemProps({
                      key: item.value,
                      item,
                      index,
                      active: highlightedIndex === index
                    })}
                    id={`${item.value}_SB`}
                  >
                    {item.text}
                  </Li>
                ))}
            </Ul>
          ) : null}
        </Wrapper>
      )}
    </Downshift>
  );
};

HomeWorkListStateDropdown.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  onSelection: PropTypes.func
};

HomeWorkListStateDropdown.defaultProps = {
  items: [],
  onSelection: () => {}
};

export default HomeWorkListStateDropdown;
